import { toNumber } from 'lodash'
import { ensureSubsystem } from '../../../utils/meetingType'
import settings from '../../components/settings'

export const getServiceById = (
  pageContentServices,
  serviceId,
  storeSubsystem
) => {
  const services = pageContentServices.filter((service) =>
    ensureSubsystem(service, storeSubsystem, settings.serviceMappings)
  )

  const service = services && services.find((s) => s.id === toNumber(serviceId))

  return service
}

export const getAppointmentFlow = (appointment) =>
  appointment.externalMeetingProvider.includes('followup')
    ? 'followup'
    : appointment.flow
